import styled from "@emotion/styled"
import { IconButton } from "@mui/material"
import CustomButton from "../../custom-button/custom-button.component"

export const Wrapper = styled.div`
  color: ${({ theme }) => theme.palette.text.secondary};
  position: fixed;
  top: 0;
  z-index: 9999;
  width: 100%;
  height: var(--viewport-height, 100vh);
  background: linear-gradient(131deg, #006e56 -2.66%, #00a179 63.25%);
  padding-top: 2rem;
  padding-bottom: 2rem;
`

export const InfoContainer = styled.div`
  /* background-color: ${({ theme }) => theme.palette.primary.light}; */
  width: 100%;
  border-radius: 8px;
  padding-top: 5rem;
  padding-bottom: 1rem;
  height: calc(var(--viewport-height, 100vh) - 100px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`
export const Button = styled(CustomButton)`
  height: 52px;
  display: flex;
  column-gap: 1rem;
`

export const CloseButton = styled(IconButton)`
  svg {
    color: ${({ theme }) => theme.palette.primary.light};
  }
`

export const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  svg {
    &.logo {
      width: 109.846px;
      height: 28px;
    }
  }
`
